export const SET_WORK_LOG_DETAILS = 'SET_WORK_LOG_DETAILS'
export const SET_WORK_LOG_NOTE_TYPES = 'SET_WORK_LOG_NOTE_TYPES'
